/** Keep in sync with @aero-judge/shared API_VERSION. */
export const API_VERSION = 'v1';
